import { License } from "./license.model";
import { Store } from "./store";

export class PrintOrder {
	key: string;

	venueKey: number;

	venue: Store;

	licenseKey: string;

	license: License;

	status: string;

	error: string;

	attemptCount: number;

	submitted: Date;

	created: Date;

	updated: Date;

	payload: any;

	deviceName: string;
	printerId: number;
	softwareVersion: string;
	duration: number; //seconds

	public constructor(init?: Partial<PrintOrder>) {
		Object.assign(this, init);
	}
}
